<template>
  <div class="absolute w-full h-full text-white" :style="{ overflow: 'clip' }">
    <div
      class="w-full h-full pointer-events-none label-container"
      :style="{ transformStyle: 'preserve-3d', display: loadingProgress < 1 ? 'none' : '' }"
    >
      <EditorModelEditorSceneLabel
        v-for="label in labels"
        :key="`${label.id}-${label.refreshKey}`"
        :inert="disabled"
        :label="label"
        :labels-manager="labelsManager"
        :selected="selectedId === label.id"
        :visible="label.visible"
        :is-model-tweening="isModelTweening"
        :always-slow-transition="alwaysSlowTransition"
        :data-testid="`label-${label.id}`"
        class="text-center"
        data-threed-entity="text-label"
        @resize="$emit('resize', { ...$event, label })"
        @deselect="$emit('blur')"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { LabelsManager } from '~/lib/three-d-resources/labels-manager'

const props = defineProps({
  labelsManager: {
    type: Object as PropType<LabelsManager>,
    required: true,
  },
  isModelTweening: {
    type: Boolean,
    default: false,
  },
  alwaysSlowTransition: {
    type: Boolean,
    default: false,
  },
  selectedId: {
    type: String as PropType<string | null>,
    default: null,
    required: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  loadingProgress: {
    type: Number,
    required: true,
  },
})

const labels = computed(() => props.labelsManager.labelsSpec.value)

defineEmits(['blur', 'resize'])
</script>
